// ABOUTME: Lazy export for settings page.
// ABOUTME: Enables code splitting for the settings module.

import { lazy } from "react"

export const Settings = lazy(() => import("./settings"))
